module.exports = __webpack_public_path__ + "img/CDF.a05b7c90.jpeg";